import React, { useEffect, useMemo, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import { Editor } from "@tinymce/tinymce-react";
import InputMask from "react-input-mask";
import { FiChevronUp, FiChevronDown, FiEdit3, FiUpload } from "react-icons/fi";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Tooltip,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Alert,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";

import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { wrap } from "lodash";
function NewModel({
  backUrl,
  api,
  getType,
  getOrientation,
  getCategory,
  handleSubmit,
  getShow,
  showData,
  getListe,
  listeData,

  //render

  renderOuiNonOptions,
  renderOrientationOptions,
  renderTypeOptions,
  renderCategorieOptions,
  //Variable
  //actif
  selectedActif,
  handleActifChange,
  // typeDocument
  selectedType,
  handleTypeChange,
  // Nom modele
  selectedNomMod,
  handleNomModChange,
  // original
  selectedOriginal,
  handleOriginalChange,
  // fisc
  selectedFisc,
  handleFiscChange,
  // Transmission API
  selectedTransmissionAPI,
  handleTransmissionAPIChange,
  //Catégorie PME
  selectedCategorie,
  handleCategorieChange,
  // Balises
  selectedBalise,
  handleBaliseChange,
  // Cumul
  selectedCumul,
  handleCumulChange,
  // Commentaire
  selectedCommentaire,
  handleCommentaireChange,
  //Champs
  selectedChamps1,
  selectedChamps2,
  selectedChamps3,
  selectedChamps4,
  selectedChamps5,
  selectedChamps6,
  handleChamps1Change,
  handleChamps2Change,
  handleChamps3Change,
  handleChamps4Change,
  handleChamps5Change,
  handleChamps6Change,
  // Images
  selectedImage1,
  selectedImage2,
  selectedImage3,
  selectedImage4,

  handleImage1Change,
  handleImage2Change,
  handleImage3Change,
  handleImage4Change,
  //Nom du fichier global
  selectedNomGlobal,
  handleNomGlobalChange,
  //Nom Fichier Individuel
  selectedNomIndividuel,
  handleNomIndividuelChange,
  //un fichier par occurence
  selectedFichierParOccurence,
  handleFichierParOccurenceChange,
  // Orientation
  selectedOrientation,
  handleOrientationChange,
  // Marge Haut
  selectedMargeHaut,
  handleMargeHautChange,
  // Marge Bas
  selectedMargeBas,
  handleMargeBasChange,
  // Marge Cote
  selectedMargeCote,
  handleMargeCoteChange,
  // Hauteur de ligne
  selectedHauteurLigne,
  handleHauteurLigneChange,
  // Hauteur  pied
  selectedHauteurPied,
  handleHauteurPiedChange,
  //Largeur
  selectedLargeur,
  handleLargeurChange,
  //Tableau
  formSignature,
  onAddFormSignature,
  onDeleteFormSignature,
  handleInputChange,
  // variable données
  // COntenu
  selectedContent,
  handleContentChange,
  selectedHeader,
  handleHeaderChange,
  selectedFooter,
  handleFooterChange,

  // custom
  CustomNavTabs,
  activeTab,
  Titre,
  TitrePage,
  colStyle,
  toggleTooltip,
  tooltipOpen,
  toggleTooltip1,
  tooltipOpen1,
  toggleTooltip2,
  tooltipOpen2,
  toggleTooltip3,
  tooltipOpen3,
  toggleTooltip4,
  tooltipOpen4,
  toggleTooltip5,
  tooltipOpen5,
  toggleTooltip6,
  tooltipOpen6,
  toggleTooltip7,
  tooltipOpen7,
  toggleTooltip8,
  tooltipOpen8,
  toggleTooltip9,
  tooltipOpen9,
  toggleTooltip10,
  tooltipOpen10,
}) {
  const { id } = useParams();
  const apiB = Config.backOffice.apiName;
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const editorRef = useRef(null);
  const log = () => {
    if (editorRef.current) {
      handleContentChange(editorRef.current.getContent());
    }
  };
  const token = localStorage.getItem("auth_token_" + apiB);

  const [showOffcanvas, setShowOffcanvas] = useState(false);

  const handleOffcanvasToggle = () => {
    setShowOffcanvas(!showOffcanvas);
    document.body.classList.toggle("offcanvas-open");
  };

  const [helper, setHelper] = useState("");

  const getHelper = async () => {
    try {
      fetch(`https://www.fluxod.com/${apiB}/publipostages/helpers`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setHelper(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (!loading) {
      getType();
      getOrientation();
      getCategory();
      getListe();
      getHelper();
    }
  }, [loading]);
  useEffect(() => {
    getShow();
  }, [selectedType]);

  const layout = localStorage.getItem("layoutMode");
  const styles = (hasError) => ({
    container: (provided) => ({
      ...provided,
      overflow: "visible",
      fontSize: "0.7109375rem",
    }),
    menu: (provided) => ({
      ...provided,
      textAlign: "left",
      overflow: "visible",
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Couleur de fond selon le mode
      color: layout === "dark" ? "#fff" : "#000", // Couleur du texte selon le mode
      marginTop: "-8px", // Au lieu de la valeur par défaut (8px)
      marginBottom: "0px",
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#555B21"
        : layout === "dark"
        ? "#444"
        : "#fff", // Ajustement du background selon le mode
      color: state.isSelected ? "white" : layout === "dark" ? "#fff" : "black", // Ajustement de la couleur selon le mode
      textAlign: "left",
      fontWeight: "normal",
      paddingLeft: 40,
      paddingTop: 10,
    }),
    groupHeading: (provided) => ({
      ...provided,
      fontWeight: "bold",
      fontSize: "15px",
      color: layout === "dark" ? "white" : "black", // Couleur selon le mode
      textAlign: "left",
    }),

    control: (provided, state) => ({
      ...provided,
      //height: "1.69125rem",
      minHeight: "1.69125rem",
      border: state.isFocused
        ? hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc"
        : hasError
        ? "1px solid red"
        : layout === "dark"
        ? "1px solid #555"
        : "1px solid #ccc", // Ajustement de la bordure selon le mode
      backgroundColor: layout === "dark" ? "#2A3042" : "#fff", // Background du contrôle selon le mode
      boxShadow: "none",
      "&:hover": {
        border: hasError
          ? "1px solid red"
          : layout === "dark"
          ? "1px solid #555"
          : "1px solid #ccc", // Ajustement de la bordure au survol selon le mode
      },
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px",
    }),
  });
  const [isCaracteristiquesAccordionOpen, setIsCaracteristiquesAccordionOpen] =
    useState(true);
  const toggleCaracteristiquesAccordion = () => {
    setIsCaracteristiquesAccordionOpen(!isCaracteristiquesAccordionOpen);
  };
  const [isFiltresAccordionOpen, setIsFiltresAccordionOpen] = useState(true);
  const toggleFiltresAccordion = () => {
    setIsFiltresAccordionOpen(!isFiltresAccordionOpen);
  };
  const [isCommentairesAccordionOpen, setIsCommentairesAccordionOpen] =
    useState(true);

  const toggleCommentairesAccordion = () => {
    setIsCommentairesAccordionOpen(!isCommentairesAccordionOpen);
  };
  const [isPresentationAccordionOpen, setIsPresentationAccordionOpen] =
    useState(true);
  const togglePresentationAccordion = () => {
    setIsPresentationAccordionOpen(!isPresentationAccordionOpen);
  };
  const PresentationData = {
    "Nom du fichier global": "",
    "Nom des fichiers individuels": "",
    "Un fichier par occurence": "",
    Orientation: "",
    "Marge haut (cm)": "",
    "Marge bas (cm)": "",
    "Marge côtés (cm)": "",
    "Hauteur de ligne (em)": "",
    "Largeur (px)": "",
    "Espace entre le footer/header et le corps": "",
  };
  const [isChampsAccordionOpen, setIsChampsAccordionOpen] = useState(true);
  const toggleChampsAccordion = () => {
    setIsChampsAccordionOpen(!isChampsAccordionOpen);
  };
  const [isImagesAccordionOpen, setIsImagesAccordionOpen] = useState(true);

  const toggleImagesAccordion = () => {
    setIsImagesAccordionOpen(!isImagesAccordionOpen);
  };
  const [isContenuAccordionOpen, setIsContenuAccordionOpen] = useState(true);
  const toggleContenuAccordion = () => {
    setIsContenuAccordionOpen(!isContenuAccordionOpen);
  };
  const [isSignatureAccordionOpen, setIsSignatureAccordionOpen] =
    useState(true);
  const toggleSignatureAccordion = () => {
    setIsSignatureAccordionOpen(!isSignatureAccordionOpen);
  };
  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Offcanvas
              isOpen={showOffcanvas}
              scrollable
              backdrop={false}
              toggle={handleOffcanvasToggle}
              style={{ width: "35%" }}
            >
              <OffcanvasHeader toggle={handleOffcanvasToggle}>
                Liste des balises
              </OffcanvasHeader>
              <OffcanvasBody>
                <div dangerouslySetInnerHTML={{ __html: listeData }} />
              </OffcanvasBody>
            </Offcanvas>
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/${api}/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          {TitrePage}
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i> Nouveau
                      </h5>
                    </div>
                    <Alert color="warning" isOpen={true}>
                      <div className="d-flex align-items-center">
                        <i className="mdi mdi-alert-outline"></i>
                        <span>
                          <strong>
                            Astuce : Pour importer un document Word :
                          </strong>
                          <ul className="mb-0 mt-1">
                            <li>
                              Sauvegardez le au format "Web Page Filtered"
                              (HTML)
                            </li>
                            <li>
                              Ouvrez le avec un éditeur de texte type Bloc Note
                            </li>
                            <li>Copiez le contenu dans le presse papier</li>
                            <li>
                              Collez le dans le modèle Fluxod au format HTML
                              (Bouton HTML dans la barre de menu de l'éditeur)
                            </li>
                          </ul>
                        </span>
                      </div>
                    </Alert>
                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Créer
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleCaracteristiquesAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Caractéristiques
                                      </span>
                                    </div>
                                    {isCaracteristiquesAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isCaracteristiquesAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Document type */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor:
                                              selectedType === null
                                                ? "white"
                                                : "white",
                                            transition: "all 0.15s ease",
                                            borderLeft:
                                              selectedType === null
                                                ? "3px solid #dc3545"
                                                : "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            if (selectedType === null) {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            } else {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }
                                          }}
                                          onMouseLeave={(e) => {
                                            if (selectedType === null) {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            } else {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Document type
                                                </span>
                                                <span className="ms-1">:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={
                                                  selectedType?.label == null
                                                    ? null
                                                    : selectedType
                                                }
                                                onChange={handleTypeChange}
                                                options={renderTypeOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedType === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedType === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Document type ne peut pas être
                                                  vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Nom du modèle */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor:
                                              selectedNomMod === ""
                                                ? "white"
                                                : "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Nom du modèle
                                                </span>
                                                <span className="ms-1">:</span>
                                              </div>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              style={{ position: "relative" }}
                                            >
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedNomMod}
                                                required
                                                onChange={handleNomModChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                              {selectedNomMod === "" && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Nom du modèle ne peut pas être
                                                  vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Original */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Original
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={
                                                  selectedOriginal?.label ==
                                                  null
                                                    ? null
                                                    : selectedOriginal
                                                }
                                                onChange={handleOriginalChange}
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Actif */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor:
                                              selectedActif === null
                                                ? "white"
                                                : "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid #dc3545",
                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#ffe6e6";
                                            e.currentTarget.style.borderLeftColor =
                                              "#dc3545";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Actif
                                                </span>
                                                <span className="ms-1">:</span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={
                                                  selectedActif?.label == null
                                                    ? null
                                                    : selectedActif
                                                }
                                                onChange={handleActifChange}
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(
                                                  selectedActif === null
                                                )}
                                                menuPortalTarget={document.body}
                                              />
                                              {selectedActif === null && (
                                                <div className="invalid-feedback d-block mt-1 small">
                                                  Actif ne peut pas être vide
                                                </div>
                                              )}
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* A transmettre au fisc */}
                                        {showData && (
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    A transmettre au fisc
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={
                                                    selectedFisc?.label == null
                                                      ? null
                                                      : selectedFisc
                                                  }
                                                  onChange={handleFiscChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(false)}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        )}

                                        {/* Transmission API CGP */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Transmission API CGP
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={
                                                  selectedTransmissionAPI?.label ==
                                                  null
                                                    ? null
                                                    : selectedTransmissionAPI
                                                }
                                                onChange={
                                                  handleTransmissionAPIChange
                                                }
                                                options={renderOuiNonOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleFiltresAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Filtres / Cumul
                                      </span>
                                    </div>
                                    {isFiltresAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isFiltresAccordionOpen}>
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {/* Catégorie de PME */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",
                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Catégorie de PME
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Select
                                                value={
                                                  selectedCategorie?.label ==
                                                  null
                                                    ? null
                                                    : selectedCategorie
                                                }
                                                onChange={handleCategorieChange}
                                                options={renderCategorieOptions()}
                                                isClearable={true}
                                                classNamePrefix="select2-selection"
                                                styles={styles(false)}
                                                menuPortalTarget={document.body}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Balises non nulle pour impression */}
                                        <div
                                          className="field-item px-2 py-1 mb-1"
                                          style={{
                                            backgroundColor: "white",
                                            transition: "all 0.15s ease",
                                            borderLeft: "3px solid transparent",

                                            position: "relative",
                                            marginBottom: "1px",
                                          }}
                                          onMouseEnter={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "#e3f2fd";
                                            e.currentTarget.style.borderLeftColor =
                                              "#007bff";
                                          }}
                                          onMouseLeave={(e) => {
                                            e.currentTarget.style.backgroundColor =
                                              "white";
                                            e.currentTarget.style.borderLeftColor =
                                              "transparent";
                                          }}
                                        >
                                          <Row className="align-items-center g-1">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Balises non nulle pour
                                                  impression
                                                </span>
                                                <i
                                                  className="bx bx-info-circle ms-1"
                                                  style={{
                                                    cursor: "pointer",
                                                    color: "#007bff",
                                                    fontSize: "14px",
                                                  }}
                                                  id="Balise"
                                                  onMouseEnter={toggleTooltip2}
                                                  onMouseLeave={toggleTooltip2}
                                                />
                                                <Tooltip
                                                  placement="top"
                                                  isOpen={tooltipOpen2}
                                                  target="Balise"
                                                  toggle={toggleTooltip2}
                                                >
                                                  {
                                                    helper?.message?.helpers[
                                                      "Balises non nulle pour impression"
                                                    ]
                                                  }
                                                </Tooltip>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col
                                              xs={12}
                                              md={8}
                                              style={{ position: "relative" }}
                                            >
                                              <input
                                                className="form-control form-control-sm shadow-sm border-0"
                                                value={selectedBalise}
                                                required
                                                onChange={handleBaliseChange}
                                                style={{
                                                  fontSize: "0.8rem",
                                                  backgroundColor: "#f8f9fa",
                                                  padding: "0.375rem 0.75rem",
                                                  height: "32px",
                                                }}
                                              />
                                              <FiEdit3
                                                size={12}
                                                className="position-absolute text-muted"
                                                style={{
                                                  right: "8px",
                                                  top: "50%",
                                                  transform: "translateY(-50%)",
                                                  pointerEvents: "none",
                                                  opacity: 0.9,
                                                }}
                                              />
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Cumul par investisseur */}
                                        {api ==
                                          "publipostages_souscriptions" && (
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor:
                                                selectedCumul === null
                                                  ? "white"
                                                  : "white",
                                              transition: "all 0.15s ease",
                                              borderLeft: "3px solid #dc3545",
                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#ffe6e6";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "#dc3545";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Cumul par investisseur
                                                  </span>
                                                  <span className="ms-1">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <Select
                                                  value={
                                                    selectedCumul?.label == null
                                                      ? null
                                                      : selectedCumul
                                                  }
                                                  onChange={handleCumulChange}
                                                  options={renderOuiNonOptions()}
                                                  isClearable={true}
                                                  classNamePrefix="select2-selection"
                                                  styles={styles(
                                                    selectedCumul === null
                                                  )}
                                                  menuPortalTarget={
                                                    document.body
                                                  }
                                                />
                                                {selectedCumul === null && (
                                                  <div className="invalid-feedback d-block mt-1 small">
                                                    Cumul par investisseur ne
                                                    peut pas être vide
                                                  </div>
                                                )}
                                              </Col>
                                            </Row>
                                          </div>
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>

                                <Row>
                                  <Col sm="12">
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleCommentairesAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Commentaires
                                          </span>
                                        </div>
                                        {isCommentairesAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse
                                        isOpen={isCommentairesAccordionOpen}
                                      >
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {/* Commentaires */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Commentaires
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <textarea
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedCommentaire}
                                                    required
                                                    onChange={
                                                      handleCommentaireChange
                                                    }
                                                    rows={3}
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      resize: "vertical",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "8px",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>

                            <Row>
                              <Col sm="6">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={togglePresentationAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Présentation / sortie
                                      </span>
                                    </div>
                                    {isPresentationAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse
                                    isOpen={isPresentationAccordionOpen}
                                  >
                                    <CardBody className="p-0">
                                      <div
                                        className="fields-container"
                                        style={{ paddingBottom: "8px" }}
                                      >
                                        {Object.entries(PresentationData).map(
                                          ([key, value], index) => (
                                            <div
                                              key={index}
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: [
                                                  "Nom du fichier global",
                                                  "Nom des fichiers individuels",
                                                  "Un fichier par occurence",
                                                  "Orientation",
                                                  "Marge haut (cm)",
                                                  "Marge bas (cm)",
                                                  "Marge côtés (cm)",
                                                  "Hauteur de ligne (em)",
                                                ].includes(key)
                                                  ? "white"
                                                  : "white",
                                                transition: "all 0.15s ease",
                                                borderLeft: [
                                                  "Nom du fichier global",
                                                  "Nom des fichiers individuels",
                                                  "Un fichier par occurence",
                                                  "Orientation",
                                                  "Marge haut (cm)",
                                                  "Marge bas (cm)",
                                                  "Marge côtés (cm)",
                                                  "Hauteur de ligne (em)",
                                                ].includes(key)
                                                  ? "3px solid #dc3545"
                                                  : "3px solid transparent",

                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                const isInvalid =
                                                  key ===
                                                    "Nom du fichier global" ||
                                                  key ===
                                                    "Nom des fichiers individuels" ||
                                                  key ===
                                                    "Un fichier par occurence" ||
                                                  key === "Orientation" ||
                                                  key === "Marge haut (cm)" ||
                                                  key === "Marge bas (cm)" ||
                                                  key === "Marge côtés (cm)" ||
                                                  key ===
                                                    "Hauteur de ligne (em)";
                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#e3f2fd";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#007bff";
                                                }
                                              }}
                                              onMouseLeave={(e) => {
                                                const isInvalid =
                                                  key ===
                                                    "Nom du fichier global" ||
                                                  key ===
                                                    "Nom des fichiers individuels" ||
                                                  key ===
                                                    "Un fichier par occurence" ||
                                                  key === "Orientation" ||
                                                  key === "Marge haut (cm)" ||
                                                  key === "Marge bas (cm)" ||
                                                  key === "Marge côtés (cm)" ||
                                                  key ===
                                                    "Hauteur de ligne (em)";

                                                if (isInvalid) {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                } else {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "transparent";
                                                }
                                              }}
                                            >
                                              {key ===
                                              "Nom du fichier global" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedNomGlobal}
                                                      required
                                                      onChange={
                                                        handleNomGlobalChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedNomGlobal ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Nom du fichier global ne
                                                        peut pas être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key ===
                                                "Nom des fichiers individuels" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <i
                                                        className="bx bx-info-circle ms-1"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "#007bff",
                                                          fontSize: "14px",
                                                        }}
                                                        id="nomFichierIndivInfoTooltip"
                                                        onMouseEnter={
                                                          toggleTooltip
                                                        }
                                                        onMouseLeave={
                                                          toggleTooltip
                                                        }
                                                      />
                                                      <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen}
                                                        target="nomFichierIndivInfoTooltip"
                                                        toggle={toggleTooltip}
                                                      >
                                                        {
                                                          helper?.message
                                                            ?.helpers[
                                                            "Nom du fichier"
                                                          ]
                                                        }
                                                      </Tooltip>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedNomIndividuel
                                                      }
                                                      required
                                                      onChange={
                                                        handleNomIndividuelChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedNomIndividuel ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Nom des fichiers
                                                        individuels ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key ===
                                                "Un fichier par occurence" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedFichierParOccurence?.label ==
                                                        null
                                                          ? null
                                                          : selectedFichierParOccurence
                                                      }
                                                      onChange={
                                                        handleFichierParOccurenceChange
                                                      }
                                                      options={renderOuiNonOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedFichierParOccurence ===
                                                          null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                    {selectedFichierParOccurence ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Un fichier par occurence
                                                        ne peut pas être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Orientation" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedOrientation?.label ==
                                                        null
                                                          ? null
                                                          : selectedOrientation
                                                      }
                                                      onChange={
                                                        handleOrientationChange
                                                      }
                                                      options={renderOrientationOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      styles={styles(
                                                        selectedOrientation ===
                                                          null
                                                      )}
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                    />
                                                    {selectedOrientation ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Orientation ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Marge haut (cm)" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedMargeHaut}
                                                      required
                                                      onChange={
                                                        handleMargeHautChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedMargeHaut ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Marge haut ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Marge bas (cm)" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedMargeBas}
                                                      required
                                                      onChange={
                                                        handleMargeBasChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedMargeBas ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Marge bas ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Marge côtés (cm)" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedMargeCote}
                                                      required
                                                      onChange={
                                                        handleMargeCoteChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedMargeCote ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Marge côtés ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key ===
                                                "Hauteur de ligne (em)" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <i
                                                        className="bx bx-info-circle ms-1"
                                                        style={{
                                                          cursor: "pointer",
                                                          color: "#007bff",
                                                          fontSize: "14px",
                                                        }}
                                                        id="HauteurLigne"
                                                        onMouseEnter={
                                                          toggleTooltip4
                                                        }
                                                        onMouseLeave={
                                                          toggleTooltip4
                                                        }
                                                      />
                                                      <Tooltip
                                                        placement="top"
                                                        isOpen={tooltipOpen4}
                                                        target="HauteurLigne"
                                                        toggle={toggleTooltip4}
                                                      >
                                                        {
                                                          helper?.message
                                                            ?.helpers[
                                                            "Hauteur de ligne (em)"
                                                          ]
                                                        }
                                                      </Tooltip>
                                                      <span className="ms-1">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedHauteurLigne
                                                      }
                                                      required
                                                      onChange={
                                                        handleHauteurLigneChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                    {selectedHauteurLigne ===
                                                      "" && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Hauteur de ligne ne peut
                                                        pas être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              ) : key === "Largeur (px)" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={selectedLargeur}
                                                      required
                                                      onChange={
                                                        handleLargeurChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              ) : key ===
                                                "Espace entre le footer/header et le corps" ? (
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      value={
                                                        selectedHauteurPied
                                                      }
                                                      required
                                                      onChange={
                                                        handleHauteurPiedChange
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiEdit3
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </Col>
                                                </Row>
                                              ) : null}
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                              <Col sm="6">
                                <Row>
                                  <Col sm="12">
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleChampsAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Champs d'impression
                                          </span>
                                        </div>
                                        {isChampsAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse isOpen={isChampsAccordionOpen}>
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {/* Champ 1 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 1
                                                    </span>
                                                    <i
                                                      className="bx bx-info-circle ms-1"
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "#007bff",
                                                        fontSize: "14px",
                                                      }}
                                                      id="champ1ToolTip"
                                                      onMouseEnter={
                                                        toggleTooltip1
                                                      }
                                                      onMouseLeave={
                                                        toggleTooltip1
                                                      }
                                                    />
                                                    <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipOpen1}
                                                      target="champ1ToolTip"
                                                      toggle={toggleTooltip1}
                                                    >
                                                      {
                                                        helper?.message
                                                          ?.helpers["Champ 1"]
                                                      }
                                                    </Tooltip>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps1}
                                                    required
                                                    onChange={
                                                      handleChamps1Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Champ 2 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 2
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps2}
                                                    required
                                                    onChange={
                                                      handleChamps2Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Champ 3 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 3
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps3}
                                                    required
                                                    onChange={
                                                      handleChamps3Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Champ 4 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 4
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps4}
                                                    required
                                                    onChange={
                                                      handleChamps4Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Champ 5 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 5
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps5}
                                                    required
                                                    onChange={
                                                      handleChamps5Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Champ 6 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Champ 6
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col
                                                  xs={12}
                                                  md={8}
                                                  style={{
                                                    position: "relative",
                                                  }}
                                                >
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    value={selectedChamps6}
                                                    required
                                                    onChange={
                                                      handleChamps6Change
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <FiEdit3
                                                    size={12}
                                                    className="position-absolute text-muted"
                                                    style={{
                                                      right: "8px",
                                                      top: "50%",
                                                      transform:
                                                        "translateY(-50%)",
                                                      pointerEvents: "none",
                                                      opacity: 0.9,
                                                    }}
                                                  />
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>

                                <Row>
                                  <Col sm="12">
                                    <Card
                                      className="shadow-sm border-0 overflow-hidden mb-4"
                                      style={{ borderRadius: "12px" }}
                                    >
                                      {/* En-tête cliquable */}
                                      <div
                                        className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                        style={{
                                          background: "#555B21",
                                          letterSpacing: "0.5px",
                                          cursor: "pointer",
                                          userSelect: "none",
                                        }}
                                        onClick={toggleImagesAccordion}
                                      >
                                        <div className="d-flex align-items-center">
                                          <span style={{ fontSize: "0.82rem" }}>
                                            Images
                                          </span>
                                        </div>
                                        {isImagesAccordionOpen ? (
                                          <FiChevronUp size={16} />
                                        ) : (
                                          <FiChevronDown size={16} />
                                        )}
                                      </div>

                                      <Collapse isOpen={isImagesAccordionOpen}>
                                        <CardBody className="p-0">
                                          <div
                                            className="fields-container"
                                            style={{ paddingBottom: "8px" }}
                                          >
                                            {/* Image 1 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                borderRadius: "6px",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Image 1
                                                    </span>
                                                    <i
                                                      className="bx bx-info-circle ms-1"
                                                      style={{
                                                        cursor: "pointer",
                                                        color: "#007bff",
                                                        fontSize: "14px",
                                                      }}
                                                      id="Image"
                                                      onMouseEnter={
                                                        toggleTooltip3
                                                      }
                                                      onMouseLeave={
                                                        toggleTooltip3
                                                      }
                                                    />
                                                    <Tooltip
                                                      placement="top"
                                                      isOpen={tooltipOpen3}
                                                      target="Image"
                                                      toggle={toggleTooltip3}
                                                    >
                                                      {
                                                        helper?.message
                                                          ?.helpers["Image 1"]
                                                      }
                                                    </Tooltip>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <div className="position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      type="file"
                                                      onChange={(e) =>
                                                        handleImage1Change(e)
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiUpload
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Image 2 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                borderRadius: "6px",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Image 2
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <div className="position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      type="file"
                                                      onChange={(e) =>
                                                        handleImage2Change(e)
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiUpload
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Image 3 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                borderRadius: "6px",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Image 3
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <div className="position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      type="file"
                                                      onChange={(e) =>
                                                        handleImage3Change(e)
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiUpload
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>

                                            {/* Image 4 */}
                                            <div
                                              className="field-item px-2 py-1 mb-1"
                                              style={{
                                                backgroundColor: "white",
                                                transition: "all 0.15s ease",
                                                borderLeft:
                                                  "3px solid transparent",
                                                borderRadius: "6px",
                                                position: "relative",
                                                marginBottom: "1px",
                                              }}
                                              onMouseEnter={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "#e3f2fd";
                                                e.currentTarget.style.borderLeftColor =
                                                  "#007bff";
                                              }}
                                              onMouseLeave={(e) => {
                                                e.currentTarget.style.backgroundColor =
                                                  "white";
                                                e.currentTarget.style.borderLeftColor =
                                                  "transparent";
                                              }}
                                            >
                                              <Row className="align-items-center g-1">
                                                <Col xs={12} md={4}>
                                                  <div className="d-flex align-items-center small text-muted">
                                                    <span
                                                      className="fw-medium"
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        letterSpacing: "0.2px",
                                                      }}
                                                    >
                                                      Image 4
                                                    </span>
                                                    <span className="ms-1 text-primary">
                                                      :
                                                    </span>
                                                  </div>
                                                </Col>
                                                <Col xs={12} md={8}>
                                                  <div className="position-relative">
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      type="file"
                                                      onChange={(e) =>
                                                        handleImage4Change(e)
                                                      }
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                      }}
                                                    />
                                                    <FiUpload
                                                      size={12}
                                                      className="position-absolute text-muted"
                                                      style={{
                                                        right: "8px",
                                                        top: "50%",
                                                        transform:
                                                          "translateY(-50%)",
                                                        pointerEvents: "none",
                                                        opacity: 0.9,
                                                      }}
                                                    />
                                                  </div>
                                                </Col>
                                              </Row>
                                            </div>
                                          </div>
                                        </CardBody>
                                      </Collapse>
                                    </Card>
                                  </Col>
                                </Row>
                              </Col>
                            </Row>
                            <Row>
                              <Row>
                                <Col sm="12">
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleContenuAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Contenu
                                        </span>
                                      </div>
                                      {isContenuAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse isOpen={isContenuAccordionOpen}>
                                      <CardBody className="p-3">
                                        {/* Liste des balises */}
                                        <div
                                          className="mb-3 px-2 py-2"
                                          style={{
                                            backgroundColor: "#f8f9fa",
                                            borderRadius: "8px",
                                            // borderLeft: "3px solid #007bff",
                                          }}
                                        >
                                          <Row className="align-items-center">
                                            <Col xs={12} md={4}>
                                              <div className="d-flex align-items-center small text-muted">
                                                <span
                                                  className="fw-medium"
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    letterSpacing: "0.2px",
                                                  }}
                                                >
                                                  Liste des balises
                                                </span>
                                                <span className="ms-1 text-primary">
                                                  :
                                                </span>
                                              </div>
                                            </Col>
                                            <Col xs={12} md={8}>
                                              <Button
                                                color="primary"
                                                size="sm"
                                                onClick={handleOffcanvasToggle}
                                                className="shadow-sm"
                                                style={{
                                                  fontSize: "0.8rem",
                                                  borderRadius: "6px",
                                                  padding: "0.375rem 0.75rem",
                                                }}
                                              >
                                                <i className="bx bx-list-ul me-1"></i>
                                                Liste
                                              </Button>
                                            </Col>
                                          </Row>
                                        </div>

                                        {/* Éditeur TinyMCE */}
                                        <div
                                          className="mb-3"
                                          style={{
                                            borderRadius: "8px",
                                            overflow: "hidden",
                                          }}
                                        >
                                          <Editor
                                            apiKey="qtpzuvciq1zhh5k87yw2b2hoie40flpoqkafr142u8lfhp6i"
                                            onInit={(evt, editor) =>
                                              (editorRef.current = editor)
                                            }
                                            value={selectedContent}
                                            init={{
                                              height: 700,
                                              menubar: true,
                                              plugins: [
                                                "advlist",
                                                "autolink",
                                                "lists",
                                                "link",
                                                "image",
                                                "charmap",
                                                "preview",
                                                "anchor",
                                                "searchreplace",
                                                "visualblocks",
                                                "code",
                                                "fullscreen",
                                                "insertdatetime",
                                                "media",
                                                "table",
                                                "code",
                                                "help",
                                                "wordcount",
                                                "autosave",
                                              ],
                                              toolbar:
                                                "undo redo | blocks | " +
                                                "bold italic forecolor | alignleft aligncenter " +
                                                "alignright alignjustify | bullist numlist outdent indent | " +
                                                "removeformat | help",
                                              content_style:
                                                "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
                                            }}
                                            onEditorChange={(content) => {
                                              handleContentChange(content);
                                            }}
                                          />
                                        </div>

                                        {/* Header et Footer */}
                                        <div
                                          className="fields-container"
                                          style={{ paddingTop: "8px" }}
                                        >
                                          {/* Header */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-start g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted pt-1">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Header
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={8}
                                                style={{ position: "relative" }}
                                              >
                                                <textarea
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedHeader}
                                                  required
                                                  onChange={handleHeaderChange}
                                                  rows={3}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    resize: "vertical",
                                                  }}
                                                />
                                                <FiEdit3
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "8px",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </div>

                                          {/* Footer */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",

                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-start g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted pt-1">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Footer
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col
                                                xs={12}
                                                md={8}
                                                style={{ position: "relative" }}
                                              >
                                                <textarea
                                                  className="form-control form-control-sm shadow-sm border-0"
                                                  value={selectedFooter}
                                                  required
                                                  onChange={handleFooterChange}
                                                  rows={3}
                                                  style={{
                                                    fontSize: "0.8rem",
                                                    backgroundColor: "#f8f9fa",
                                                    borderRadius: "6px",
                                                    padding: "0.375rem 0.75rem",
                                                    resize: "vertical",
                                                  }}
                                                />
                                                <FiEdit3
                                                  size={12}
                                                  className="position-absolute text-muted"
                                                  style={{
                                                    right: "8px",
                                                    top: "8px",
                                                    pointerEvents: "none",
                                                    opacity: 0.9,
                                                  }}
                                                />
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                </Col>
                              </Row>
                              <Col sm="12">
                                <Card
                                  className="shadow-sm border-0 overflow-hidden mb-4"
                                  style={{ borderRadius: "12px" }}
                                >
                                  {/* En-tête cliquable */}
                                  <div
                                    className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                    style={{
                                      background: "#555B21",
                                      letterSpacing: "0.5px",
                                      cursor: "pointer",
                                      userSelect: "none",
                                    }}
                                    onClick={toggleSignatureAccordion}
                                  >
                                    <div className="d-flex align-items-center">
                                      <span style={{ fontSize: "0.82rem" }}>
                                        Signature électronique
                                      </span>
                                    </div>
                                    {isSignatureAccordionOpen ? (
                                      <FiChevronUp size={16} />
                                    ) : (
                                      <FiChevronDown size={16} />
                                    )}
                                  </div>

                                  <Collapse isOpen={isSignatureAccordionOpen}>
                                    <CardBody>
                                      <Col sm="12">
                                        <div className="table-responsive">
                                          <table
                                            className="table table-bordered rounded-3 overflow-hidden"
                                            style={{
                                              borderCollapse: "collapse",
                                              width: "100%",
                                            }}
                                          >
                                            <thead>
                                              <tr>
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#ebd826",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                  }}
                                                >
                                                  Page signature
                                                  <i
                                                    className="bx bx-info-circle ms-1"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "white",
                                                      fontSize: "14px",
                                                    }}
                                                    id="Page-Signature"
                                                    onMouseEnter={
                                                      toggleTooltip5
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip5
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen5}
                                                    target="Page-Signature"
                                                    toggle={toggleTooltip5}
                                                  >
                                                    {
                                                      helper?.message?.helpers[
                                                        "Signataires"
                                                      ]
                                                    }
                                                  </Tooltip>
                                                </th>
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#ebd826",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                  }}
                                                >
                                                  Position signature
                                                  <i
                                                    className="bx bx-info-circle ms-1"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "white",
                                                      fontSize: "14px",
                                                    }}
                                                    id="Position-Signature"
                                                    onMouseEnter={
                                                      toggleTooltip6
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip6
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen6}
                                                    target="Position-Signature"
                                                    toggle={toggleTooltip6}
                                                  >
                                                    {
                                                      helper?.message?.helpers[
                                                        "Position signature"
                                                      ]
                                                    }
                                                  </Tooltip>
                                                </th>
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#ebd826",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                  }}
                                                >
                                                  Signataire
                                                  <i
                                                    className="bx bx-info-circle ms-1"
                                                    style={{
                                                      cursor: "pointer",
                                                      color: "white",
                                                      fontSize: "14px",
                                                    }}
                                                    id="Signataire"
                                                    onMouseEnter={
                                                      toggleTooltip7
                                                    }
                                                    onMouseLeave={
                                                      toggleTooltip7
                                                    }
                                                  />
                                                  <Tooltip
                                                    placement="top"
                                                    isOpen={tooltipOpen7}
                                                    target="Signataire"
                                                    toggle={toggleTooltip7}
                                                  >
                                                    {
                                                      helper?.message?.helpers[
                                                        "Signataires"
                                                      ]
                                                    }
                                                  </Tooltip>
                                                </th>
                                                <th
                                                  className=""
                                                  style={{
                                                    background: "#ebd826",
                                                    color: "white",
                                                    paddingTop: "5px",
                                                    paddingBottom: "5px",
                                                    width: "1%",
                                                  }}
                                                >
                                                  Actions
                                                </th>
                                              </tr>
                                            </thead>
                                            <tbody>
                                              {formSignature?.map((rowData) => (
                                                <tr key={rowData.index}>
                                                  <td>
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                      value={
                                                        rowData.page_signature
                                                      }
                                                      name="page_signature"
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                      value={
                                                        rowData.position_signature
                                                      }
                                                      name="position_signature"
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <input
                                                      className="form-control form-control-sm"
                                                      style={{
                                                        minWidth: "100px",
                                                      }}
                                                      value={rowData.signataire}
                                                      name="signataire"
                                                      onChange={(e) =>
                                                        handleInputChange(
                                                          rowData.index,
                                                          e.target.name,
                                                          e.target.value
                                                        )
                                                      }
                                                    />
                                                  </td>
                                                  <td>
                                                    <i
                                                      className="bx bx-trash"
                                                      style={{
                                                        fontSize: "20px",
                                                        paddingTop: "5px",
                                                        textAlign: "center",
                                                        verticalAlign: "middle",
                                                        cursor: "pointer",
                                                      }}
                                                      onClick={() =>
                                                        onDeleteFormSignature(
                                                          rowData.index
                                                        )
                                                      }
                                                    ></i>
                                                  </td>
                                                </tr>
                                              ))}
                                              <tr>
                                                <td colSpan="4">
                                                  <input
                                                    type="button"
                                                    style={{
                                                      background: "#555B21",
                                                      color: "white",
                                                      paddingTop: "5px",
                                                      paddingBottom: "5px",
                                                    }}
                                                    className="btn btn-info mt-3 mt-lg-0"
                                                    value="Ajouter"
                                                    onClick={onAddFormSignature}
                                                  />
                                                </td>
                                              </tr>
                                            </tbody>
                                          </table>
                                        </div>
                                      </Col>
                                    </CardBody>
                                  </Collapse>
                                </Card>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewModel;
